import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Role } from "/app/src/models";
import Box from "/app/src/components/generic/components/box";

/**
 * Renders a role menu component.
 *
 * @param {Object} props - The component properties.
 * @param {Role} props.role - The role object used to display details.
 * @returns {JSX.Element} The rendered role menu component.
 */
export default function RoleMenu({ role }: { role: Role }) {
  const { t } = useTranslation();
  return (
    <div className="userMenu sideMenu">
      <Box>
        <ul>
          <li>
            <NavLink to={`/users/roles/${role.id}`}>
              <>
                {t("translation:role")} {t("translation:details")}
              </>
            </NavLink>
          </li>
        </ul>
      </Box>
    </div>
  );
}
